module.exports = __webpack_public_path__ + "static/media/info.ddc03143.svg";